import { format } from "date-fns";
import DownloadDocumentResponse from "models/downloadDocumentResponse/DownloadDocumentResponse";
import { Subdomain } from "shared/Enums";

class GlobalUtility {
  public GetDateText(date: Date): string {
    return `${format(new Date(date), 'M/d/yy')}`;
  }

  public CreateFileDownloadResponse(response: any): DownloadDocumentResponse {

    var contentFileName: string = response.headers['content-disposition'].split('filename=')[1].slice(0);
    var fileName = contentFileName.slice(0, contentFileName.indexOf(';'));
    var file = new Blob([response.data], { type: 'octet/stream' });

    return { file: file, fileName: fileName } as DownloadDocumentResponse;
  }

  public GetSubdomain(): Subdomain {
    let subdomainText = window.location.hostname.split('.')
    if (subdomainText.findIndex(item => item.endsWith('dealer')) >= 0) {
      return Subdomain.Dealer;
    } else {
      return Subdomain.Admin;
    }
  }

  public ValidateEmailAddress(email: string): boolean {
    // Expecting __@__.__
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  public ValidateSSN(ssn: string): boolean {
    // Expecting a string in the format 000-00-0000
    let validSSN: boolean = true;
    let ssnSegments: string[] = ssn.replace(/\s/g, "").split('-'); // Removing spaces added from the pattern format framework

    validSSN = ssnSegments.length === 3 && ssnSegments[0].length === 3 && ssnSegments[1].length === 2 && ssnSegments[2].length === 4
    return validSSN;
  }

  public ValidateEIN(ein: string): boolean {
    // Expecting a string in the format 00-0000000
    let validEIN: boolean = true;
    let einSegments: string[] = ein.split('-');

    validEIN = einSegments.length === 2 && einSegments[0].length === 2 && einSegments[1].length === 7
    return validEIN;
  }

  public FormatRelativeDate(dateStr: string): string {
    const date = new Date(dateStr);
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'yesterday';
    if (diffDays < 0) return `in ${Math.abs(diffDays)} days`;
    return `${diffDays} days ago`;
  }
}

const globalUtility = new GlobalUtility();
export default globalUtility;